import React from 'react';

const SuccessGlassIcon = () => {
  return (
    <svg width="96" height="89" viewBox="0 0 96 89" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M80.0466 10.5919L54.8577 3.86227C45.7211 1.42125 38.9679 5.33414 36.5117 14.4741L28.1928 45.4301C25.6963 54.7199 29.6148 61.3554 38.7514 63.7964L63.9403 70.5261C73.2242 73.0065 79.7949 69.1733 82.2914 59.8835L90.6103 28.9275C93.0665 19.7875 89.3305 13.0723 80.0466 10.5919Z"
        fill="url(#paint0_linear_10562_123363)"
      />
      <g opacity="0.5" filter="url(#filter0_f_10562_123363)">
        <path
          d="M73.4648 19.0679L56.3033 14.483C50.0785 12.8199 45.4775 15.4858 43.804 21.7129L38.1363 42.8035C36.4354 49.1328 39.1051 53.6536 45.33 55.3167L62.4914 59.9017C68.8166 61.5916 73.2933 58.98 74.9941 52.6508L80.6619 31.5601C82.3353 25.333 79.79 20.7578 73.4648 19.0679Z"
          fill="#39B93A"
        />
      </g>
      <g filter="url(#filter1_b_10562_123363)">
        <mask
          id="path-3-outside-1_10562_123363"
          maskUnits="userSpaceOnUse"
          x="0.5"
          y="15.6094"
          width="74"
          height="74"
          fill="black">
          <rect fill="white" x="0.5" y="15.6094" width="74" height="74" />
          <path d="M52.8369 16.6094H21.7985C9.66235 16.6094 1.5 25.1049 1.5 37.741V66.9041C1.5 79.5046 9.66235 88.0001 21.7985 88.0001H52.8369C64.973 88.0001 73.0996 79.5046 73.0996 66.9041V37.741C73.0996 25.1049 64.973 16.6094 52.8369 16.6094Z" />
        </mask>
        <path
          d="M52.8369 16.6094H21.7985C9.66235 16.6094 1.5 25.1049 1.5 37.741V66.9041C1.5 79.5046 9.66235 88.0001 21.7985 88.0001H52.8369C64.973 88.0001 73.0996 79.5046 73.0996 66.9041V37.741C73.0996 25.1049 64.973 16.6094 52.8369 16.6094Z"
          fill="#39B93A"
          fillOpacity="0.35"
        />
        <path
          d="M52.8369 17.6094C53.3892 17.6094 53.8369 17.1617 53.8369 16.6094C53.8369 16.0571 53.3892 15.6094 52.8369 15.6094V17.6094ZM52.8369 15.6094C52.2846 15.6094 51.8369 16.0571 51.8369 16.6094C51.8369 17.1617 52.2846 17.6094 52.8369 17.6094V15.6094ZM52.8369 15.6094H21.7985V17.6094H52.8369V15.6094ZM21.7985 15.6094C15.4886 15.6094 10.1432 17.8233 6.37703 21.7439C2.61419 25.6609 0.5 31.2053 0.5 37.741H2.5C2.5 31.6406 4.46698 26.6192 7.81935 23.1294C11.1684 19.6431 15.9723 17.6094 21.7985 17.6094V15.6094ZM0.5 37.741V66.9041H2.5V37.741H0.5ZM0.5 66.9041C0.5 73.4227 2.61464 78.9582 6.37745 82.8705C10.1435 86.7862 15.4886 89.0001 21.7985 89.0001V87.0001C15.9722 87.0001 11.1681 84.9663 7.81893 81.4841C4.46653 77.9985 2.5 72.986 2.5 66.9041H0.5ZM21.7985 89.0001H52.8369V87.0001H21.7985V89.0001ZM52.8369 89.0001C59.1469 89.0001 64.4836 86.786 68.2409 82.8696C71.9946 78.9569 74.0996 73.4215 74.0996 66.9041H72.0996C72.0996 72.9873 70.1412 77.9999 66.7977 81.485C63.4577 84.9664 58.663 87.0001 52.8369 87.0001V89.0001ZM74.0996 66.9041V37.741H72.0996V66.9041H74.0996ZM74.0996 37.741C74.0996 31.2066 71.9951 25.6623 68.2413 21.7448C64.4839 17.8235 59.147 15.6094 52.8369 15.6094V17.6094C58.6629 17.6094 63.4574 19.643 66.7972 23.1285C70.1408 26.6178 72.0996 31.6393 72.0996 37.741H74.0996Z"
          fill="url(#paint1_linear_10562_123363)"
          mask="url(#path-3-outside-1_10562_123363)"
        />
      </g>
      <g filter="url(#filter2_bd_10562_123363)">
        <mask id="path-5-inside-2_10562_123363" fill="white">
          <path d="M33.0505 63.8965C32.2485 63.8965 31.4466 63.5931 30.8345 62.9827L22.3392 54.5122C21.1148 53.2914 21.1148 51.3139 22.3392 50.0967C23.5635 48.8759 25.5432 48.8723 26.7676 50.0931L33.0505 56.3577L47.8286 41.6226C49.053 40.4018 51.0327 40.4018 52.257 41.6226C53.4814 42.8434 53.4814 44.8209 52.257 46.0417L35.2665 62.9827C34.6543 63.5931 33.8524 63.8965 33.0505 63.8965Z" />
        </mask>
        <path
          d="M33.0505 63.8965C32.2485 63.8965 31.4466 63.5931 30.8345 62.9827L22.3392 54.5122C21.1148 53.2914 21.1148 51.3139 22.3392 50.0967C23.5635 48.8759 25.5432 48.8723 26.7676 50.0931L33.0505 56.3577L47.8286 41.6226C49.053 40.4018 51.0327 40.4018 52.257 41.6226C53.4814 42.8434 53.4814 44.8209 52.257 46.0417L35.2665 62.9827C34.6543 63.5931 33.8524 63.8965 33.0505 63.8965Z"
          fill="url(#paint2_linear_10562_123363)"
        />
        <path
          d="M22.3392 50.0967L22.4802 50.2385L22.4804 50.2383L22.3392 50.0967ZM33.0505 56.3577L32.9092 56.4993L33.0505 56.6401L33.1917 56.4993L33.0505 56.3577ZM52.257 46.0417L52.1158 45.9001L52.257 46.0417ZM35.2665 62.9827L35.4077 63.1243L35.2665 62.9827ZM33.0505 63.6965C32.299 63.6965 31.5486 63.4124 30.9757 62.8411L30.6932 63.1243C31.3446 63.7739 32.1981 64.0965 33.0505 64.0965V63.6965ZM30.9757 62.8411L22.4804 54.3706L22.1979 54.6538L30.6932 63.1243L30.9757 62.8411ZM22.4804 54.3706C21.3343 53.2278 21.3346 51.3774 22.4802 50.2385L22.1982 49.9549C20.895 51.2504 20.8953 53.355 22.1979 54.6538L22.4804 54.3706ZM22.4804 50.2383C23.627 49.0951 25.4804 49.0921 26.6264 50.2348L26.9088 49.9515C25.6061 48.6526 23.5001 48.6568 22.1979 49.9551L22.4804 50.2383ZM26.6264 50.2348L32.9092 56.4993L33.1917 56.216L26.9088 49.9515L26.6264 50.2348ZM33.1917 56.4993L47.9698 41.7642L47.6874 41.481L32.9092 56.216L33.1917 56.4993ZM47.9698 41.7642C49.1161 40.6213 50.9695 40.6213 52.1158 41.7642L52.3983 41.481C51.0958 40.1824 48.9898 40.1824 47.6874 41.481L47.9698 41.7642ZM52.1158 41.7642C53.2618 42.9069 53.2618 44.7574 52.1158 45.9001L52.3983 46.1833C53.701 44.8844 53.701 42.7799 52.3983 41.481L52.1158 41.7642ZM52.1158 45.9001L35.1253 62.8411L35.4077 63.1243L52.3983 46.1833L52.1158 45.9001ZM35.1253 62.8411C34.5523 63.4124 33.8019 63.6965 33.0505 63.6965V64.0965C33.9028 64.0965 34.7563 63.7739 35.4077 63.1243L35.1253 62.8411Z"
          fill="url(#paint3_linear_10562_123363)"
          fillOpacity="0.5"
          mask="url(#path-5-inside-2_10562_123363)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_10562_123363"
          x="23.6338"
          y="0"
          width="71.5293"
          height="74.4023"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur_10562_123363" />
        </filter>
        <filter
          id="filter1_b_10562_123363"
          x="-23.5"
          y="-8.39062"
          width="121.6"
          height="121.391"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_10562_123363"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_10562_123363"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_bd_10562_123363"
          x="6.4209"
          y="25.707"
          width="61.7549"
          height="53.1914"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="7.5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_10562_123363"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_backgroundBlur_10562_123363"
            result="effect2_dropShadow_10562_123363"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_10562_123363"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_10562_123363"
          x1="94.4999"
          y1="14.4534"
          x2="39.6555"
          y2="48.118"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#39B93A" />
          <stop offset="1" stopColor="#0B8F0C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10562_123363"
          x1="12.8975"
          y1="24.9265"
          x2="58.409"
          y2="81.4584"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.25" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10562_123363"
          x1="50.9239"
          y1="44.8946"
          x2="15.5854"
          y2="46.4723"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10562_123363"
          x1="24.8415"
          y1="48.486"
          x2="51.8047"
          y2="48.6898"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SuccessGlassIcon;
